import {
  HorizontalLayout,
  RendererProps,
  rankWith,
  uiTypeIs,
} from '@jsonforms/core';
import { VanillaRendererProps } from '@jsonforms/vanilla-renderers';
import { ReactElement } from 'react';
import './ionic-renderers.css';
import { renderChildren } from './layout.utils';

const IonicHorizontalLayout = (
  props: RendererProps & VanillaRendererProps
): ReactElement => {
  const { schema, uischema, visible, path } = props;

  const horizontalLayout = uischema as HorizontalLayout;

  const childClassNames = 'horizontal-layout-item';

  return (
    <div
      className={'horizontal-layout-container'}
      hidden={visible === undefined || visible === null ? false : !visible}
    >
      {renderChildren(horizontalLayout, schema, childClassNames, path)}
    </div>
  );
};

const IonicHorizontalLayoutTester = rankWith(1, uiTypeIs('HorizontalLayout'));

export { IonicHorizontalLayout, IonicHorizontalLayoutTester };
